import React from "react"

import {
  Wrapper,
  NBLInfoContent,
  NBLMiddleInfoContent,
} from "./../../PrintListContent.style"
import { ReceiptUpperLimitManagement } from "../../../../types"
import { PRINT_CONFIGURATION_OPTION_VALUES } from "../../../../constants"
import { t } from "i18next"
import { DefaultSheetTitle } from "../header/sheetTitle/DefaultSheetTitle"
import { YearMonth } from "../../common/header/YearMonth"
import { KobeChildDetail } from "../header/childDetail/KobeChildDetail"
import { ManagementFacility } from "../../common/header/ManagementFacility"
import { KobeUpperMonthLimit } from "../../common/header/upperMonthLimit/KobeUpperMonthLimit"
import { DefaultUpperLimitManagementResult } from "../../common/header/upperLimitManagementResult/DefaultUpperLimitManagementResult"
import { KobeFormat } from "../body/KobeFormat"
import { KobeSignature } from "../../common/footer/signature/KobeSignature"

type Props = {
  receiptUpperLimitManagement: ReceiptUpperLimitManagement
  printConfig: string[]
}

export function KobeFlame({
  receiptUpperLimitManagement,
  printConfig = [],
}: Props) {
  return (
    <Wrapper>
      {printConfig.includes(
        PRINT_CONFIGURATION_OPTION_VALUES.PRINT_FORM_NUMBER
      ) && <small>{t("(Form 2)")}</small>}

      {/* --- Start Header */}
      <DefaultSheetTitle />
      <YearMonth
        year={receiptUpperLimitManagement.year}
        month={receiptUpperLimitManagement.month}
      />
      <NBLInfoContent length={1}>
        <div className={"top__table_content"}>
          <KobeChildDetail
            municipalityNumber={receiptUpperLimitManagement.municipality_number}
            receivingCertificateNumber={
              receiptUpperLimitManagement.receiving_certificate_number
            }
            childName={receiptUpperLimitManagement.child_name}
            parentName={receiptUpperLimitManagement.parent_name}
            printConfig={printConfig}
          />
        </div>
        <div className={"top__table_content"}>
          <ManagementFacility
            facilityName={receiptUpperLimitManagement.facility_name}
            facilityNumber={receiptUpperLimitManagement.facility_number}
          />
        </div>
      </NBLInfoContent>
      <NBLMiddleInfoContent>
        <div className={"NBLMiddleInfoContent"}>
          <div className={"nbl_info_top_content"}>
            <KobeUpperMonthLimit
              burdenMaxMonth={receiptUpperLimitManagement.burden_max_month}
              localBurdenMaxMonth={
                receiptUpperLimitManagement.local_burden_max_month
              }
            />
          </div>
          <div className={"nbl_info_bottom_content"}>
            <DefaultUpperLimitManagementResult
              managementResult={receiptUpperLimitManagement.management_result}
            />
          </div>
        </div>
      </NBLMiddleInfoContent>
      {/* --- End Header */}

      {/* --- Start Body */}
      <KobeFormat
        facilities={receiptUpperLimitManagement.facilities}
        totalAmount={receiptUpperLimitManagement.total_amount}
        totalBurdenAmount={receiptUpperLimitManagement.total_burden_amount}
        managementResultBurdenAmount={
          receiptUpperLimitManagement.management_result_burden_amount
        }
        totalInsuranceAmount={
          receiptUpperLimitManagement.total_insurance_amount
        }
        managementResultInsuranceAmount={
          receiptUpperLimitManagement.total_management_result_insurance_amount
        }
        totalLocalExemption={receiptUpperLimitManagement.total_local_exemption}
        localBurdenAmount={receiptUpperLimitManagement.local_burden_amount}
      />
      {/* --- End Body */}

      {/* --- Start Footer */}
      <KobeSignature printConfig={printConfig} />
      {/* --- End Footer */}
    </Wrapper>
  )
}
